// ------------------------------------------------------------------------------
// name: detail
// author: mudas
// created: 2025/1/9
// ------------------------------------------------------------------------------

import { UserCertifyType } from 'common/constants';
import { RequirementType } from './type';
import { QualificationStatus, RecommendStatusEnum } from './status';

export enum SocialArtworkStatusEnum {
  All = 'All',
  FineArtwork = 20,
  NonFineArtwork = 30,
  UnclassifiedArtwork = 0,
}

export const SocialArtworkStatusName = {
  [SocialArtworkStatusEnum.All]: '全部作品',
  [SocialArtworkStatusEnum.FineArtwork]: '美术作品',
  [SocialArtworkStatusEnum.NonFineArtwork]: '非美术作品',
  [SocialArtworkStatusEnum.UnclassifiedArtwork]: '未分类作品',
};

export const SocialArtworkStatusTag = {
  [SocialArtworkStatusEnum.All]: '全部',
  [SocialArtworkStatusEnum.FineArtwork]: '美术',
  [SocialArtworkStatusEnum.NonFineArtwork]: '非美术',
  [SocialArtworkStatusEnum.UnclassifiedArtwork]: '未分类',
};

export const SocialArtworkStatusTagColor = {
  [SocialArtworkStatusEnum.All]: 'var(--color-text)',
  [SocialArtworkStatusEnum.FineArtwork]: 'var(--color-success)',
  [SocialArtworkStatusEnum.NonFineArtwork]: 'var(--color-error)',
  [SocialArtworkStatusEnum.UnclassifiedArtwork]: 'var(--color-warning)',
};

export const SocialArtworkStatusOptions = [
  { label: SocialArtworkStatusName[SocialArtworkStatusEnum.All], value: SocialArtworkStatusEnum.All },
  { label: SocialArtworkStatusName[SocialArtworkStatusEnum.FineArtwork], value: SocialArtworkStatusEnum.FineArtwork },
  {
    label: SocialArtworkStatusName[SocialArtworkStatusEnum.NonFineArtwork],
    value: SocialArtworkStatusEnum.NonFineArtwork,
  },
  {
    label: SocialArtworkStatusName[SocialArtworkStatusEnum.UnclassifiedArtwork],
    value: SocialArtworkStatusEnum.UnclassifiedArtwork,
  },
];

// 创作者作品
export interface ArtWorkType {
  fileId?: string;
  previewUrl: string;
  artworkUrl: string;
  artworkName: string;
  artworkId: string;

  illegal?: boolean;
  style?: string[];
  requirementType?: RequirementType;
  index?: number;

  workStatus: SocialArtworkStatusEnum;
  deleteLock?: number;
}

// 创作者类型
export interface ArtistType {
  uniqueId: number; //创作者用户id
  qualificationId?: number; //创作者资质id
  nickName: string; //创作者昵称
  avatar: string; //头像
  realNameAuthenticated?: boolean; //是否实名认证
  artistQualificationStatus: QualificationStatus; //资质认证状态
  requirementType: string[]; //创作者类型，
  personalProfile?: string; //个人简介
  personalExternalLink?: string; //社交媒体链接
  artwork: ArtWorkType[]; //作品
  avgScore?: string; //平均评分
  isConcerned?: boolean; // 是否已关注
}

// 创作者详细资料（创作者列表、分享创作者列表、工作台我的创作者列表等）
export interface ArtistDetailType extends ArtistType {
  artworkId?: string;
  artworkUrl?: string;
  isMe?: boolean;
  userCertifyType: UserCertifyType;
  recommendStatus?: RecommendStatusEnum;
  mediaUserId?: number;
  userCode?: string;
  mediaNickname?: string;
  recommendTaskId?: number;
}
